import { Pipe, PipeTransform } from '@angular/core';
import { IUnit } from '../interfaces/unit';
import { PowerUnits } from '../models/power-units';

@Pipe({
  name: 'hpToPower',
  standalone: true
})
export class HpToPowerPipe implements PipeTransform {

  transform(value: number, powerUnits: IUnit, decimals: number = 2): number {
    return parseFloat(PowerUnits.hpToPower(value, powerUnits.display).toFixed(decimals))
  }

}
